import { GetAccountSentimentReportPercentilesAverageRequestDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-percentiles-average.request.dto';
import { LogManager } from '../../../../src/common/port/log/log.manager.port';
import { GetAccountSentimentReportPercentilesAverageMetricsQuery } from '../../../../src/interface/queries/sentiment/get-account-sentiment-report-percentiles-average.query';
import { GetAccountSentimentReportPercentilesAverageResponseDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-percentiles-average.response.dto';
import { AccountSentimentReportPercentilesAverageAggregateRootMapper } from '../../../infrastructure/mappers/sentiment/account-sentiment-report-percentiles-average-aggregate-root.mapper';

export class GetAccountSentimentReportPercentilesAverageController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountSentimentReportPercentilesAverageMetricsQuery,
    protected readonly mapper: AccountSentimentReportPercentilesAverageAggregateRootMapper
  ) {}

  async get(
    props: GetAccountSentimentReportPercentilesAverageRequestDto
  ): Promise<GetAccountSentimentReportPercentilesAverageResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountSentimentReportPercentilesAverageController.get encountered an error ${error}`
      );
    }
  }
}
